import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import '../../stylesheet/cardactivity.css';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import html2canvas from 'html2canvas';
import * as JSpdf from 'jspdf'
// import '../../thirdparty/jsencrypt.min.js'
import * as actions from '../../actions/actions.jsx'
import { connect } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../loader/loader.jsx'
import $ from 'jquery'
import s from '../../services/allservices.jsx'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {
    Link
} from 'react-router-dom';


const styles = {
    block: {
        maxWidth: 250,
    },
    radioButton: {
        marginBottom: 5,
        marginTop: 5,
        width: "33%",
        display: "inline"
    },
    blockmargin: {
        marginBottom: 10,
        marginRight: 10
    },
    labelStyle: {
        padding: 0,
        color: "#fff",
        marginTop: 20
    },
    inputStle: {
        marginRight: 5,
        marginTop: 10
    },
    groupstyle: {
        display: "flex",
        width: "100%"
    },
    radioIcon: {
        fill: "#333"
    },
    calendarStyle: {
        // backgroundColor:"#333"
    },
    calendarTextStyle: {
        color: "#fff",
        // backgroundColor:"#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        cardState: state.getCardReducer.cardState,
        cardactivity: state.getCardActivityReducer.cardactivity
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
        fetchCardActivity(cardDetailId, startDate, endDate, statementPeriod, transactionType) {

            dispatch(
                actions.getCardActivity(cardDetailId, startDate, endDate, statementPeriod, transactionType)
            )
        },
    })
const JSEncrypt = window.JSEncrypt
class Activity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialvalue: '',
            value: '',
            loader: true,
            QuickLoad: false,
            disabled: true,
            cardDetailsId: 1,
            selectedCard: [],
            statementPeriod: 7,
            activityFromDate: "",
            activityToDate: "",
            value4: 'all',
            todatestate: true,
            cardInUse: [],
            selectedOption: "tab1",
            transactionType: ""
        }
    }

    handleSelect = (event, index, value) => {
        const { cardState } = this.props
        for (let i = 0; i < cardState.body.length; i++) {
            if (cardState.body[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: cardState.body[i]
                })
            }
        }
        this.setState({ cardDetailsId: value }, () => {
            loader: true
            this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)

        }, () => {

        });

    }
    handleChange7(e) {
        let _this = this
        this.setState({
            selectedOption: e.target.value,
            transactionType: "P",
            loader: true
        }, () => {
            this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)
        }, () => {
            this.setState({
                loader: false
            })
        })
    }

    handleChange8(e) {
        let _this = this
        this.setState({
            selectedOption: e.target.value,
            transactionType: "A",
            loader: true
        }, () => {
            this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)
        }, () => {
            this.setState({
                loader: false
            })
        })
    }
    handleSelectmonth = (event, index, value) => {
        const { cardactivity } = this.props
        this.setState({
            statementPeriod: value
        }, () => {

            if (this.state.statementPeriod === 0) {
                let _this = this
                const state = {
                    activityFromDate: this.state.activityFromDate,
                    activityToDate: this.state.activityToDate,
                    cardDetailsId: this.state.cardDetailsId,
                    statementPeriod: this.state.statementPeriod

                }
                this.setState({
                    loader: true
                })
                let token = "Token " + localStorage.getItem('token')
                fetch(s.get_cardactivity, {
                    method: "POST",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': token
                    },
                    body: JSON.stringify(state)

                })
                    .then(response => {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        this.setState({
                            loader: false
                        })
                    })
            } else {
                this.setState({
                    loader: true
                })
                this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)

            }

        });
    }
    handleChange = (event, index, value) => {
        this.setState({
            value4: event.target.value

        })
    };
    handledate = (e, date) => {
        this.setState({
            activityFromDate: this.converDate(date),
            activityToDate: this.converDate(date)
        }, () => {
            if (this.state.activityFromDate !== "" && this.state.activityToDate !== " ") {
                this.setState({
                    disabled: false
                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })



    }
    handlecardactivity = () => {
        const { fromAccount, amount, toAccount } = this.state
        if (Date.parse(this.state.activityToDate) <= Date.parse(this.state.activityFromDate)) {
            this.setState({
                todatestate: false,
            })
        }
        else {

            this.setState({
                activityFromDate: this.state.activityFromDate,
                activityToDate: this.state.activityToDate,
                applicationId: "gmcabs",
                cardDetailsId: this.state.cardDetailsId,
                statementPeriod: 0

            }, () => {
                this.setState({
                    loader: true
                })
                this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)

            }, () => {
                this.setState({
                    loader: false
                })
            })
        }
    }

    componentDidMount() {
        console.log("didMount")
        let _this = this

        this.setState({
            cardDetailsId: this.props.cardState.body[0].cardDetailsId,
            cardInUse: this.props.cardState.body[0],
            transactionType: "P",
            initialvalue: "initial"
        }, () => {
            _this.props.fetchCardActivity(_this.props.cardState.body[0].cardDetailsId, _this.state.activityFromDate, _this.state.activityToDate, _this.state.statementPeriod, _this.state.transactionType)
        })

    }
    handleFromDate = (e, date) => {
        this.setState({
            activityFromDate: this.converDate(date)

            // dob: this.converDate(date)
        }, () => {
            if (this.state.activityFromDate.length !== 0 && this.state.activityToDate.length !== 0) {
                this.setState({
                    disabled: false

                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })
    }
    handleToDate = (e, date) => {
        this.setState({
            activityToDate: this.converDate(date)
            // dob: this.converDate(date)
        }, () => {

            if (this.state.activityFromDate.length !== 0 && this.state.activityToDate.length !== 0) {
                this.setState({
                    disabled: false

                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })
    }
    comparedate = () => {
        const { activityFromDate, activityToDate } = this.state
        if (Date.parse(activityToDate) <= Date.parse(activityFromDate)) {

        }
    }
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [
            (mm > 9 ? '' : '0') + mm,
            (dd > 9 ? '' : '0') + dd,
            date.getFullYear()
        ].join('/');
    }
    formatDate = (date) => {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        return [

            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            date.getFullYear()
        ].join('/');
    }
    handleChangeMinDate = (event, date) => {
        this.setState({
            statementFromDate: this.converDate(date),
        });
    };
    componentDidUpdate(prevProps) {
    }
    removetodate = () => {
        this.setState({
            todatestate: true
        })
    }
    handleChangeMaxDate = (event, date) => {
        this.setState({
            statementTodDate: date,
        });
    }
    handleSelect1 = (event, index, value) => {

        const { cardState } = this.props
        for (let i = 0; i < cardState.body.length; i++) {
            console.log("inside for loop " + cardState.body[i].cardDetailsId)
            console.log("value " + value)
            if (cardState.body[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: cardState.body[i],
                    selectedCard: cardState.body[i],
                    initialvalue: "changed",
                    cardDetailsId: value
                })
            }
        }

        let _this = this

        this.setState({
            cardDetailsId: value
        }, () => {
            for (let i = 0; i < cardState.body.length; i++) {
                if (this.state.cardDetailsId === cardState.body[i].cardDetailsId) {

                    this.setState({

                        selectedCard: cardState.body[i]
                    }, () => {
                        _this.setState({
                            loader: true
                        })
                        _this.props.fetchCardActivity(cardState.body[i].cardDetailsId, _this.state.activityFromDate, _this.state.activityToDate, _this.state.statementPeriod, _this.state.transactionType)

                    }, () => {
                        _this.setState({
                            loader: false
                        })
                    })
                }
            }
        });

    }

    componentWillReceiveProps(nextProps) {
        let _this = this
        console.log("inside will receive props")
        this.setState({
            loader: true
        })
        try {
            if (_this.state.initialvalue === 'initial') {
                console.log("inside if")
                if (nextProps.cardState && nextProps.cardState.length !== 0) {
                    this.setState({
                        loader: false,
                        selectedCard: nextProps.cardState.body[0],
                        value: nextProps.cardState.body[0].cardDetailsId
                    })
                }
            }
            else {
                console.log("inside else")
                this.setState({
                    loader: false
                })
                // if (nextProps.cardState && nextProps.cardState.length !== 0) {
                //     for (let i = 0; i < nextProps.cardState.body.length; i++) {
                //         if (nextProps.cardState.body[i].cardDetailsId === _this.state.value) {
                //             console.log(nextProps.cardState.body[i])
                //             this.setState({                              
                //                 loader: false,
                //                 selectedCard: nextProps.cardState.body[i]
                //             })
                //         }
                //     }
                // }
            }
        } catch (e) {

        }

    }
    handleDownload() {
       

        // setTimeout(() => {
            if (  this.props.cardactivity.body.transactions.length !== 0) {
                this.setState({
                    quickLoad: true
                })
                const input = document.getElementById('carddivPrint');
                html2canvas(input)
                    .then((canvas) => {
                        const img = canvas.toDataURL('image/png');
                        //const pdf = new jsPDF('p', 'mm');
                        //let img = pdf.addImage(imgData, 'JPEG', 0, 0);
                        var imgWidth = 210;
                        var pageHeight = 295;
                        var imgHeight = canvas.height * imgWidth / canvas.width;
                        var heightLeft = imgHeight;

                        const pdf = new JSpdf('p', 'mm')
                        var position = 0;

                        pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
                        heightLeft -= pageHeight;

                        while (heightLeft >= 0) {
                            position = heightLeft - imgHeight;
                            pdf.addPage();
                            pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
                            heightLeft -= pageHeight;
                        }
                        // pdf.output('dataurlnewwindow');
                        pdf.save("download.pdf");
                    });
                    setTimeout(() => {
                        this.setState({ quickLoad: false })
                    }, 2000)
            }
        // }, 10)
        else {
            toast.error('No content available for download.', {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });
        }
        

    }

    handleShowMeOption = (event, value) => {
    }
    render() {
        const { cardState, cardactivity } = this.props
        const { todatestate, cardDetailsId, selectedCard, activityFromDate, activityToDate, value4, cardInUse } = this.state

        return (
            <div className="row" >

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-sm-12">
                    <AuthNavbar />
                </div>
                <div className="container" style={{ marginTop: "80px" }}>
                    <div className="row">
                        <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div>
                        <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                            <div className="row box-shadow-style" style={{ padding: "12px 0px", minHeight: "476px" }}>
                                <div className="col-sm-12">
                                    <div className="header-style">
                                        <h4>
                                            Card Activity
                                        </h4>
                                        <p>
                                            Below is your Card balance. You can search for all transactions or you can search by debits or credits only. Simply enter a statement period and click on the ‘Show’ button. Pending transactions have not yet settled on your account.
    
                                        </p>
                                    </div>
                                </div>
                                {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 ?

                                    <div className="col-sm-12">
                                        <div className="card-activity">
                                            <div className="col-md-12" style={{ padding: "0px 15px" }}>
                                                <div className="summary-header">
                                                    <div className="row">
                                                        <div className="col-sm-5" style={{ padding: "13px 0px 0px 0px" }}>{selectedCard.cardProgramId}</div>
                                                        <div className="col-sm-7">
                                                            <div className="row">
                                                                <div className="col-sm-5 text-right" style={{ padding: "13px 13px" }}>
                                                                    <b>Card Account</b>
                                                                </div>
                                                                <div className="col-sm-7">
                                                                    <SelectField
                                                                        floatingLabelText=""
                                                                        onChange={this.handleSelect1}
                                                                        className="input-width"
                                                                        name="Selected Card"

                                                                        value={cardDetailsId}>
                                                                        {cardState.body.map((value, i) =>
                                                                            <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                                        )}
                                                                    </SelectField>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="tile box-shadow-style" style={{ marginTop: "-12px" }}>
                                                <div className="row">
                                                    <div className="col-md-6 col-sm-12">
                                                        <div className="row">
                                                            <div className="col-md-6  tilepadding">
                                                                <label className="tilecontent">Card Number </label>
                                                            </div>
                                                            <div className="col-md-6 text-left tilepadding">
                                                                <span className="tileheadername">{selectedCard.cardNumber} </span><br />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6  tilepadding">
                                                                <label className="tilecontent">Name on Card </label>
                                                            </div>
                                                            <div className="col-md-6 text-left tilepadding">
                                                                <span className="tileheadername">{selectedCard.firstName + " " + selectedCard.lastName}  </span><br />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6  tilepadding">
                                                                <label className="tilecontent">Last Credit Posted </label>
                                                            </div>
                                                            <div className="col-md-6 text-left tilepadding">
                                                                <span className="tileheadername"> {selectedCard.lastCreditPosted}  </span><br />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-sm-12">
                                                        <div className="row">
                                                            <div className="col-md-4  tilepadding">
                                                                <label className="tilecontent">Available Balance </label>
                                                            </div>
                                                            <div className="col-md-8 text-left tilepadding">
                                                                <span className="tileheadername">{selectedCard.availableBalance}</span><br />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4  tilepadding">
                                                                <label className="tilecontent">Ledger Balance </label>
                                                            </div>
                                                            <div className="col-md-8 text-left tilepadding">
                                                                <span className="tileheadername">{selectedCard.ledgerBalance}</span><br />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4  tilepadding">
                                                                <label className="tilecontent">Card Status </label>
                                                            </div>
                                                            <div className="col-md-8 text-left tilepadding">
                                                                <span className="tileheadername">{selectedCard.cardStatus}  </span><br />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    : <Loader />}

                                <div className="col-sm-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row">
                                                <div className="col-sm-2 nopadding" style={{ marginTop: "15px" }}>Statement Period</div>
                                                <div className="col-sm-10">
                                                    <div className="row">
                                                        <div className="col-sm-4">
                                                            <SelectField

                                                                onChange={this.handleSelectmonth}
                                                                className="input-width"
                                                                name="statementPeriod"
                                                                value={this.state.statementPeriod}
                                                            >
                                                                {/* <MenuItem value={1} primaryText="Select transfer status" /> */}
                                                                <MenuItem value={0} primaryText="Select Duration" />
                                                                <MenuItem value={1} primaryText="Today" />
                                                                <MenuItem value={2} primaryText="Yesterday" />
                                                                <MenuItem value={3} primaryText="Last Week  " />
                                                                <MenuItem value={4} primaryText="This Month" />
                                                                <MenuItem value={5} primaryText="This Year" />
                                                                <MenuItem value={6} primaryText="Last Month" />
                                                                <MenuItem value={7} primaryText="Last 3 Months" />
                                                                <MenuItem value={8} primaryText="Last 6 Months" />
                                                                <MenuItem value={9} primaryText="Last 9 Months" />
                                                                <MenuItem value={10} primaryText="Last 12 Months" />
                                                                <MenuItem value={11} primaryText="Last 24 Months" />



                                                            </SelectField>

                                                        </div>
                                                        <div className="col-sm-2 text-right" style={{ padding: "7px 13px" }}>
                                                            <b>Show Me</b>
                                                        </div>
                                                        <div className="col-sm-6">

                                                            <div className="row">
                                                                <RadioButtonGroup name="shipSpeed" defaultSelected="all" style={styles.groupstyle} onChange={this.handleChange.bind(this)}>

                                                                    <RadioButton
                                                                        value="all"
                                                                        label="All"
                                                                        style={styles.radioButton}
                                                                        iconStyle={styles.radioIcon}
                                                                        valueSelected="all"

                                                                    />
                                                                    <RadioButton
                                                                        value="debit"
                                                                        label="Debit"
                                                                        style={styles.radioButton}
                                                                        iconStyle={styles.radioIcon}
                                                                        valueSelected="debit"

                                                                    />
                                                                    <RadioButton
                                                                        value="credit"
                                                                        label="Credit"
                                                                        style={styles.radioButton}
                                                                        iconStyle={styles.radioIcon}
                                                                        valueSelected="credit"

                                                                    />
                                                                </RadioButtonGroup>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <div className="row input-group" >
                                                        <div className="col-sm-2 input-icon" >
                                                            <i className="fa fa-calendar text-dark " aria-hidden="true"></i>
                                                        </div>
                                                        <div className="col-sm-10 nopadding" >
                                                            <DatePicker
                                                                hintText="From Date"
                                                                container="inline"
                                                                name="activityFromDate"
                                                                className="input-width"
                                                                onChange={this.handleFromDate}
                                                                style={styles.calendarStyle}
                                                                formatDate={this.formatDate}
                                                                maxDate={new Date()}
                                                                textFieldStyle={styles.calendarTextStyle}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="row input-group" >
                                                        <div className="col-sm-2 activityinput" >
                                                            <i className="fa fa-calendar text-dark " aria-hidden="true"></i>
                                                        </div>
                                                        <div className="col-sm-10 nopadding" >
                                                            <DatePicker hintText="To Date"
                                                                onChange={this.handleToDate}
                                                                container="inline"
                                                                name="activityToDate"
                                                                maxDate={new Date()}
                                                                onFocus={this.removetodate}
                                                                formatDate={this.formatDate}
                                                                className="input-width"
                                                                errorText={todatestate ? null : "To-date should not less than from-date."} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <RaisedButton
                                                        label="Show"
                                                        className="pull-right"
                                                        disabled={this.state.disabled}
                                                        // style={styles.button}
                                                        backgroundColor="#333"
                                                        labelColor="#fff"
                                                        onClick={this.handlecardactivity}
                                                        style={{ marginTop: "10px" }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 transfer" style={{ marginTop: "30px" }}>
                                        <div className="row box-shadow-style" >
                                            <div className="pc-tab">
                                                <input id="tab1" type="radio" name="pct" value="tab1" checked={this.state.selectedOption === 'tab1'} onChange={this.handleChange7.bind(this)} />
                                                <input id="tab2" type="radio" name="pct" value="tab2" checked={this.state.selectedOption === 'tab2'} onChange={this.handleChange8.bind(this)} />
                                                <div className="pull-right" style={{ marginRight: "20px" }}>
                                                    <button className="btn btn-default" onClick={this.handleDownload.bind(this)} style={{ marginTop: "9px", padding: "3px 6px", fontSize: 14 }}><i className="fa fa-download" aria-hidden="true" style={{ marginRight: 10 }}></i>Download as PDF</button>
                                                </div>
                                                <nav>
                                                    <ul>
                                                        <li className="tab1">
                                                            <label style={{ cursor: "pointer" }} htmlFor="tab1">Posted Transactions</label>
                                                        </li>
                                                        <li className="tab2">
                                                            <label style={{ cursor: "pointer" }} htmlFor="tab2">Pending Transactions</label>
                                                        </li>
                                                    </ul>
                                                </nav>
                                                <section>
                                                    <div className="tab1" style={{ minHeight: "100px" }}>
                                                    {this.state.quickLoad && <Loader />}
                                                        {this.state.loader ? <div ><Loader /></div> :
                                                            cardState.status === 200 && cardInUse.length !== 0 ?
                                                                <table className="table table-striped" id="carddivPrint">                                                                 
                                                                    <thead>
                                                                        <tr style={{ fontSize: "13px" }}>
                                                                            <th style={{ width: "2%", padding: "10px 15px" }} >Trans Date</th>
                                                                            <th style={{ width: "5%" }} >Trans Time</th>
                                                                            <th style={{ width: "40%", padding: "21px 6px" }}>Description</th>
                                                                            <th style={{ width: "5%" }}>Card Number	</th>
                                                                            <th style={{ width: "15%" }}>Debit <br />(-)</th>
                                                                            <th style={{ width: "15%" }}>Credit <br />(+)</th>
                                                                            <th style={{ width: "15%" }}>Running Balance</th>
                                                                        </tr>
                                                                    </thead>                                                                  <tbody>
                                                                
                                                                        { ( value4 === "all") ?
                                                                          cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                <tr style={{ fontSize: "13px" }} key={i}>
                                                                                    <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                    <td>{cardactivity.body.transactions[i].transferTime} {}</td>
                                                                                    <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}</td>
                                                                                    <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                    {(cardactivity.body.transactions[i].debitAmount !== "") ?
                                                                                        <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                        :
                                                                                        <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                    }
                                                                                    {(cardactivity.body.transactions[i].creditAmount !== "") ?
                                                                                        <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                        :
                                                                                        <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                    }
                                                                                    <td>{cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                </tr>) :
                                                                            (value4 === "debit" && cardactivity.body.hasDebitRecords === true) ?
                                                                                cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                    (cardactivity.body.transactions[i].debitAmount !== "") ?
                                                                                        <tr style={{ fontSize: "13px" }} key={i}>
                                                                                            <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                            <td>{cardactivity.body.transactions[i].transferTime} {}</td>
                                                                                            <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                            <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                            <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                            <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                            <td> {cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                        </tr>
                                                                                        :
                                                                                        <tr>
                                                                                        </tr>
                                                                                )
                                                                                :
                                                                                (value4 === "debit" && cardactivity.body.hasDebitRecords === false) ?
                                                                                    <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                        No Records Found
                                                                                 </span>
                                                                                    :
                                                                                    (value4 === "credit" && cardactivity.body.hasCreditRecords === true) ?
                                                                                        cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                            (cardactivity.body.transactions[i].creditAmount !== "") ?
                                                                                                <tr style={{ fontSize: "13px" }} key={i}>
                                                                                                    <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                                    <td>{cardactivity.body.transactions[i].transferTime} {}</td>
                                                                                                    <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                                    <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                                    <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                    <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                    <td> {cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                                </tr>
                                                                                                :
                                                                                                <tr>
                                                                                                </tr>
                                                                                        ) :
                                                                                        (value4 === "credit" && cardactivity.body.hasCreditRecords === false) ?
                                                                                            <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                                No Records Found
                                                                                         </span> :
                                                                                            <div>
                                                                                            </div>
                                                                        }
                                                                        {cardactivity.status === 200 && cardactivity.body.transactions.length === 0 &&
                                                                            <div className="row">
                                                                                <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                    No Records Found
                                                                 </span>
                                                                            </div>}
                                                                    </tbody>
                                                                </table>
                                                                : <Loader />}
                                                    </div>
                                                    <div className="tab2" style={{ minHeight: "100px" }}>
                                                        {this.state.loader ? <div ><Loader /></div> :
                                                            cardState.status === 200 && cardInUse.length !== 0 ?
                                                                <table className="table table-striped" id="carddivPrint">
                                                                    <thead>
                                                                        <tr style={{ fontSize: "13px" }}>
                                                                            <th style={{ width: "2%", padding: "10px 15px" }} >Trans Date</th>
                                                                            <th style={{ width: "5%" }} >Trans Time</th>
                                                                            <th style={{ width: "40%", padding: "21px 6px" }}>Description</th>
                                                                            <th style={{ width: "5%" }}>Card Number	</th>
                                                                            <th style={{ width: "15%" }}>Debit <br />(-)</th>
                                                                            <th style={{ width: "15%" }}>Credit <br />(+)</th>
                                                                            <th style={{ width: "15%" }}>Running Balance</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {(value4 === "all") ?
                                                                         cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                <tr style={{ fontSize: "13px" }} key={i}>
                                                                                    <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                    <td>{cardactivity.body.transactions[i].transferTime} {}</td>
                                                                                    <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}</td>
                                                                                    <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                    {(cardactivity.body.transactions[i].debitAmount !== "") ?
                                                                                        <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                        :
                                                                                        <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                    }
                                                                                    {(cardactivity.body.transactions[i].creditAmount !== "") ?
                                                                                        <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                        :
                                                                                        <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                    }

                                                                                    <td> {cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                </tr>) :
                                                                            (value4 === "debit" && cardactivity.body.hasDebitRecords === true) ?
                                                                                cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                    (cardactivity.body.transactions[i].debitAmount !== "") ?
                                                                                        <tr style={{ fontSize: "13px" }} key={i}>
                                                                                            <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                            <td>{cardactivity.body.transactions[i].transferTime} {}</td>
                                                                                            <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                            <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                            <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                            <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                            <td> {cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                        </tr>
                                                                                        :
                                                                                        <tr>
                                                                                        </tr>
                                                                                )
                                                                                :
                                                                                (value4 === "debit" && cardactivity.body.hasDebitRecords === false) ?
                                                                                    <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                        No Records Found
                                                                                    </span>
                                                                                    :
                                                                                    (value4 === "credit" && cardactivity.body.hasCreditRecords === true) ?
                                                                                        cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                            (cardactivity.body.transactions[i].creditAmount !== "") ?
                                                                                                <tr style={{ fontSize: "13px" }} key={i}>
                                                                                                    <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                                    <td>{cardactivity.body.transactions[i].transferTime} {}</td>
                                                                                                    <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}{cardactivity.body.transactions[i].comments}  </td>
                                                                                                    <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                                    <td> {cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                    <td> {cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                    <td>{cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                                </tr>
                                                                                                :
                                                                                                <tr>
                                                                                                </tr>
                                                                                        ) :
                                                                                        (value4 === "credit" && cardactivity.body.hasCreditRecords === false) ?
                                                                                            <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                                No Records Found
                                                                                          </span> :
                                                                                            <div>
                                                                                            </div>
                                                                                          }
                                                                        {cardactivity.status === 200 && cardactivity.body.transactions.length === 0 &&
                                                                            <div className="row">
                                                                                <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                    No Records Found
                                                                         </span>                                                                         
                                                                            </div>}
                                                                    </tbody>
                                                                </table>
                                                                : <Loader />}
                                                    </div>
                                                </section>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>



        );
    }
}
Activity.defaultProps = {
    cardState: {
        status: 600
    },
    cardactivity: {
        status: 600
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Activity);


// WEBPACK FOOTER //
// ./src/components/cardsummary/activity.jsx